//Import required libraies
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//Import Custom Component
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import AlertHandler from "../../components/Sidenav/AlertHandler";

//Import styles
import "./LayoutTopSideBottom.scss";

function LayoutTopSideBottom(props) {
  const { user, children, match } = props;
  return (
    <div className={`${user.theme} page`}>
      <Header match={match} />
      <section className="body">
        <AlertHandler match={match} />
        <main className={`content full`}>{children}</main>
      </section>
      <Footer />
    </div>
  );
}

LayoutTopSideBottom.propTypes = {
  children: PropTypes.node,
  user: PropTypes.object,
  match: PropTypes.object,
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps)(LayoutTopSideBottom);
